<script>
export default {
    name: 'BaseDatatable',
    props: {
        drfprovider: {
            type: Function,
            required: false,
            default: () => null
            },
        provider: {
            type: Function,
            required: false,
            default: () => null
            },
        tableheaders: {
            type: [Array, Object],
            required: true
            },
        perpage: {
            type: Number,
            required: false,
            default: 10
            },
        pageoptions: {
            type: Array,
            required: false,
            default() {
                return [10, 20, 30]
                }
            },
        sortby: {
            type: String,
            required: false,
            default: ''
            },
        sortdesc: {
            type: NaN,
            required: false,
            default: null
        },
        emptyText: {
            type: String,
            default: 'Sin registros para mostrar'
        },
        emptyFilteredText: {
            type: String,
            default: 'No se encontraron registros'
        },
    },
    data() {
        return {
            isBusy: false,
            filter: null,
            totalRows: 1,
            currentPage: 1,
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.currentPage = 1
        },
        baseProvider(ctx){
            let promise = this.drfprovider(ctx)
            if (promise){
                return promise.then((data) =>{
                    this.totalRows = data.count
                    return data.results
                })
            }else{
                return this.provider(ctx)
            }
        },
        refresh(){
            this.$refs.table.refresh()
        }
    }
}
</script>
<template>
    <b-container fluid class="p-0">
        <b-row>
            <b-col sm="12" offset-md="6" md="6" class="my-1">
                <b-form-group
                label="Filtro"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
                >
                <b-input-group size="sm">
                    <b-form-input
                    id="filterInput"
                    v-model="filter"
                    debounce="600"
                    type="search"
                    placeholder="Escribe para buscar"
                    ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
                    </b-input-group-append>
                </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="5" md="6" class="my-1">
                <b-form-group
                label="Registros/página"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="4"
                label-align-sm="right"
                label-size="sm"
                label-for="perPageSelect"
                class="mb-0"
                >
                    <b-form-select
                        id="perPageSelect"
                        v-model="perpage"
                        size="sm"
                        :options="pageoptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col lg=3></b-col>
            <b-col sm="7" md="6" lg="3" class="my-1">
                <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perpage"
                align="fill"
                size="sm"
                class="my-0"
                ></b-pagination>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-table
                    ref="table"
                    striped hover small
                    :items="baseProvider"
                    :fields="tableheaders"
                    :per-page="perpage"
                    :current-page="currentPage"
                    :busy="isBusy"
                    :filter="filter"
                    :sort-by.sync="sortby"
                    :sort-desc.sync="sortdesc"
                    show-empty
                    @filtered="onFiltered"
                >
                    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
                    <template v-slot:table-busy>
                        <div class="text-center text-corp my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> Cargando ...</strong>
                        </div>
                    </template>
                </b-table>
                Mostrando {{ !totalRows ? 0 : ((currentPage - 1) * perpage) + 1 }} - {{ !totalRows ? 0 : currentPage * perpage >= totalRows ? totalRows : currentPage * perpage }} de {{ totalRows }} registros totales
            </b-col>
        </b-row>
    </b-container>
</template>